











































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import CheckBoxesDropdown from '~/components/partials/CheckBoxesDropdown.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import MapOutline from '~/components/icons/MapOutline.vue';
import LocalisationDestinationCard from '~/components/cards/LocalisationDestinationCard.vue';
import LocalisationDestinationMobileModal from '~/components/lists/items/LocalisationDestinationMobileModal.vue';
import LabelsDropdown from "~/components/partials/LabelsDropdown.vue";
import LocalisationEventsMobileModal from "~/components/lists/items/LocalisationEventsMobileModal.vue";
import SportsDropdown from "~/components/partials/SportsDropdown.vue";
import LocalisationRoutesMobileModal from "~/components/lists/items/LocalisationRoutesMobileModal.vue";

const Modal = {
  MOBILE_DESTINATION: 'destinations',
};

@Component({
  components: {
    LocalisationRoutesMobileModal,
    SportsDropdown,
    LocalisationEventsMobileModal,
    LabelsDropdown,
    CheckBoxesDropdown,
    CheckInput,
    MapOutline,
    LocalisationDestinationCard,
    LocalisationDestinationMobileModal,
  },
  computed: {
    ...mapState([
      'isMobileDownloadBannerDisplayed',
    ]),
    ...mapState('explorer', [
      'displayLocalisationMap',
      'mobileLocalisationFiltersModal',
      'destinationDestinationFilters',
      'destinationsList',
      'sports',
    ]),
  },
})
export default class LocalisationDestinations extends Vue {
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(Array) sportsToShow: Types.SportItem[];
  @Prop(Array) destinations: [];

  $refs: {
    destinationTab: HTMLDivElement,
    container: HTMLDivElement,
  }

  isMobileDownloadBannerDisplayed : boolean;
  displayLocalisationMap: boolean;
  mobileLocalisationFiltersModal: string;
  destinationDestinationFilters: {[key: string]: any};
  destinationsList: Types.DestinationList;
  sports: Types.SportItem[];

  Modal = Modal;
  modal: string = '';

  landscapeTypes: Array<Types.CheckboxElement> = [
    { checked: false, id: 'COASTLINE', name: this.$t('localisationDestinations.types.coastline') },
    { checked: false, id: 'MOUNTAIN', name: this.$t('localisationDestinations.types.mountain') },
    { checked: false, id: 'URBAN', name: this.$t('localisationDestinations.types.urban') },
    { checked: false, id: 'VALLEY', name: this.$t('localisationDestinations.types.valley') },
  ];

  selectedDestinations: Array<Types.CheckboxElement> = [];
  selectedLandscapes: Array<Types.CheckboxElement> = [];

  selectedLabels: Array<Number> = [];

  selectResorts: boolean = false;
  calculatedDivHeight: number = 300;

  emitHasScrolled () {
    if (
      this.destinations.length &&
      (this.destinations.length !== this.destinationsList.total)
    ) {
      this.$emit('load-routes');
    }
  }

  @Emit('search-destinations')
  searchDestinations () {
    this.$refs.container.scroll({ top: 0 });

    return {
      landscape: this.selectedLandscapes.map((l: Types.CheckboxElement) => l.id ? l.id : l),
      label: this.selectedLabels?.map((s: any) => s.id ? s.id : s),
      respect: this.selectResorts,
      type_id: this.selectedDestinations.map((t: Types.CheckboxElement) => t.id ? t.id : t),
      sport: this.value,
    };
  }

  @Watch('mobileLocalisationFiltersModal')
  handleModalDisplay (val: string) {
    if (val === Modal.MOBILE_DESTINATION) this.modal = Modal.MOBILE_DESTINATION;
  }

  mounted () {
    this.handleHeight();

    window.addEventListener('resize', this.handleHeight);

    this.$nuxt.$on('reset-queries', this.resetFilters);

    if (this.destinationDestinationFilters.landscape) {
      this.selectedLandscapes = this.destinationDestinationFilters.landscape;
      this.destinationDestinationFilters.landscape.map((id: string) => {
        this.landscapeTypes.map((t: Types.CheckboxElement) => {
          if (id === t.id) t.checked = true;
        });
      });
    }

    if (this.destinationDestinationFilters.respect) {
      this.selectResorts = true;
    }

    if (this.destinationDestinationFilters.label) {
      this.selectedLabels = this.destinationDestinationFilters.label;
    }
    if (this.destinationDestinationFilters.sport) {
      this.destinationDestinationFilters.sport.map((s: string | number) => {
        const newValue = [...this.value];
        newValue.push(s);

        this.$emit('input', newValue);
      });
      this.$emit('input', [...new Set(this.value)]);
    }
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.handleHeight);
  }

  handleHeight () {
    this.calculatedDivHeight = this.$refs.destinationTab.clientHeight + 199;
  }

  handleModalClose () {
    this.modal = '';
    this.$store.commit('explorer/SET_MOBILE_LOCALISATION_FILTERS_MODAL', '');
  }

  /* eslint array-callback-return: 0 */
  populateFilterArray (data: any) {
    const self: any = this;
    const vueData: any = self[data.data];
    const isDuplicated: any = vueData.filter((item: any) => item.id === data.element.id).length === 1;
    if (!isDuplicated) {
      vueData.push(data.element);
    } else {
      vueData.map((filter: any, index: number) => {
        if (filter.id === data.element.id) {
          vueData.splice(index, 1);
        }
      });
    }
    return vueData.slice(0);
  }

  resetFilters () {
    /* eslint no-return-assign: 0 */
    this.value = [];
    this.selectedDestinations = [];
    this.selectedLandscapes = [];
    this.selectedLabels = [];
    this.value = [];
    this.landscapeTypes.forEach((d: Types.CheckboxElement) => d.checked = false);
    this.selectResorts = false;
    this.$root.$emit('reset-checkboxes');
  }

  @Watch('value')
  watch () {
    this.$emit('input', this.value);
  }
}
